function notEqual(a, b) {
  // eslint-disable-next-line eqeqeq
  return a != b;
}

notEqual.op = '!=';

export default notEqual;
